import React from 'react';
import { ArrowRight, Instagram, Youtube } from 'lucide-react';
import { Button } from './ui/button';
import { influencerData } from '../mock';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center animate-slow-zoom"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1920&h=1080&fit=crop)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0F0D]/95 via-[#0A0F0D]/90 to-[#0A0F0D]/95"></div>
        <div className="absolute inset-0 bg-[#22C55E]/5"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-center">
        <div className="space-y-8 animate-fade-in-up">
          {/* Main Headline */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-tight">
            <span className="block text-white mb-2 animate-slide-down">
              {influencerData.tagline}
            </span>
            <span className="block bg-gradient-to-r from-[#22C55E] to-[#4ADE80] text-transparent bg-clip-text animate-slide-down animation-delay-200">
              {influencerData.subtitle}
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl md:text-2xl text-[#94A3B8] max-w-3xl mx-auto animate-fade-in animation-delay-400">
            Helping fitness brands reach millions with content that converts.
            <span className="block mt-2 text-[#22C55E] font-semibold">
              {influencerData.followers} followers • {influencerData.monthlyReach} monthly reach
            </span>
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in animation-delay-600">
            <Button 
              className="bg-[#16A34A] hover:bg-[#22C55E] text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-lg shadow-[#22C55E]/30 hover:shadow-[#22C55E]/50 transition-all duration-300 hover:scale-105 glow-button"
            >
              Let's Collaborate
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              variant="outline"
              className="border-2 border-[#22C55E] text-[#22C55E] hover:bg-[#22C55E]/10 px-8 py-6 text-lg font-semibold rounded-lg transition-all duration-300 hover:scale-105"
            >
              View Case Studies
            </Button>
          </div>

          {/* Social Links */}
          <div className="flex gap-6 justify-center items-center pt-8 animate-fade-in animation-delay-800">
            <a 
              href="#" 
              className="flex items-center gap-2 text-[#94A3B8] hover:text-[#22C55E] transition-colors duration-300"
            >
              <Instagram className="h-5 w-5" />
              <span className="text-sm font-medium">{influencerData.instagram}</span>
            </a>
            <div className="h-6 w-px bg-[#94A3B8]/30"></div>
            <a 
              href="#" 
              className="flex items-center gap-2 text-[#94A3B8] hover:text-[#22C55E] transition-colors duration-300"
            >
              <Youtube className="h-5 w-5" />
              <span className="text-sm font-medium">{influencerData.youtube}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#22C55E]/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-1.5 bg-[#22C55E] rounded-full animate-scroll"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;